import { render, staticRenderFns } from "./BunkerRoute.vue?vue&type=template&id=3d99bb76"
import script from "./BunkerRoute.vue?vue&type=script&lang=js"
export * from "./BunkerRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports